import { Flex } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors, Sizes } from "@jsq/ds/styles";
import { CaseStatusRenderer } from "~/pages/Compliance/ComplianceTable/CaseStatusRenderer";
import { StatusTextBlock } from "~/pages/Compliance/ComplianceTable/CaseStatusRenderer/StatusTextBlock";
import { bucketToCaseStatus } from "./buckets";
import { ONBOARDING_NO_PROGRAM, type OnboardingState } from "./resolveOnboardingState";

export const OnboardingStatusLabel = ({ state }: { state: OnboardingState }) => {
  if (state.kind === "no-program") {
    return <StatusTextBlock primaryText={ONBOARDING_NO_PROGRAM} color={Colors.Neutral500} />;
  }
  if (state.kind === "action-required") {
    return (
      <Flex alignItems="center" gap={Sizes.SM}>
        <Icon type="exclamation-triangle" variant="outline" color={Colors.Warning600} />
        <StatusTextBlock
          primaryText="Action required"
          color={Colors.Warning600}
          paddingTop={Sizes.XS}
        />
      </Flex>
    );
  }
  return <CaseStatusRenderer params={{ value: bucketToCaseStatus(state.status) }} showIcon />;
};
